export const state = {
  employeedeductions: [],
  systemDeduction:[]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/employeedeductions/state.js